import React, { useEffect, useState } from "react";
import { adminApi } from "@/lib/adminApi";
import { CreditCard, TrendingUp } from "lucide-react";

export default function AdminSubscriptions() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const r = await adminApi.get("/admin/subscriptions");
                setData(r.data);
            } catch (e) {}
            setLoading(false);
        })();
    }, []);

    const maxRev = Math.max(1, ...(data?.revenue_series || []).map((r) => r.amount_inr));

    return (
        <div data-testid="admin-subscriptions-page">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="font-display text-3xl font-black">Subscriptions</h1>
                    <p className="text-sm text-white/50">{data?.active || 0} active</p>
                </div>
            </div>

            {loading ? (
                <div className="mt-6 text-white/50 text-sm">Loading…</div>
            ) : (
                <>
                    {/* Revenue chart */}
                    <div className="mt-4 rounded-2xl border border-white/10 bg-white/5 p-4">
                        <div className="text-[10px] font-black uppercase tracking-widest text-white/50 flex items-center gap-1.5">
                            <TrendingUp className="h-3 w-3" strokeWidth={3} /> Revenue · last 30 days
                        </div>
                        <div className="mt-3 flex items-end gap-1 h-32">
                            {(data?.revenue_series || []).length === 0 ? (
                                <div className="w-full text-center text-white/50 text-sm py-8">No paid events yet</div>
                            ) : (
                                data.revenue_series.map((r, i) => (
                                    <div key={i} className="flex-1 flex flex-col items-center gap-1" title={`${r.date}: ₹${r.amount_inr}`}>
                                        <div className="w-full bg-[#22C55E] rounded-sm" style={{ height: `${(r.amount_inr / maxRev) * 100}%`, minHeight: 2 }} />
                                        <div className="text-[8px] text-white/40 rotate-90 origin-center whitespace-nowrap">{r.date.slice(5)}</div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>

                    {/* Active subscribers table */}
                    <div className="mt-4 rounded-2xl border border-white/10 bg-white/5 overflow-hidden">
                        <div className="p-4 border-b border-white/10">
                            <div className="text-[10px] font-black uppercase tracking-widest text-white/50 flex items-center gap-1.5">
                                <CreditCard className="h-3 w-3" strokeWidth={3} /> Active subscribers
                            </div>
                        </div>
                        <table className="w-full text-sm">
                            <thead>
                                <tr className="text-left text-[10px] font-black uppercase tracking-widest text-white/50 border-b border-white/10">
                                    <th className="px-4 py-3">User</th>
                                    <th className="px-4 py-3">Email</th>
                                    <th className="px-4 py-3">Until</th>
                                </tr>
                            </thead>
                            <tbody data-testid="admin-subs-table">
                                {(data?.subscribers || []).length === 0 ? (
                                    <tr><td colSpan={3} className="text-center text-white/50 py-8">No active subscribers</td></tr>
                                ) : data.subscribers.map((u) => (
                                    <tr key={u.user_id} className="border-b border-white/5 hover:bg-white/5">
                                        <td className="px-4 py-3 font-semibold">{u.name || "—"}</td>
                                        <td className="px-4 py-3 text-white/70">{u.email}</td>
                                        <td className="px-4 py-3 text-white/70">{(u.premium_until || "").slice(0, 10)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </div>
    );
}
